import { render } from "./InboxMessageBubble.vue?vue&type=template&id=e0ff705e&scoped=true&ts=true"
import script from "./InboxMessageBubble.vue?vue&type=script&lang=ts"
export * from "./InboxMessageBubble.vue?vue&type=script&lang=ts"

import "./InboxMessageBubble.vue?vue&type=style&index=0&id=e0ff705e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ff705e"]])

export default __exports__